import{jsx as e,Fragment as o,jsxs as t}from"react/jsx-runtime";import{useRef as a,useCallback as r}from"react";import{createPortal as i}from"react-dom";import d from"react-draggable";import{styled as l}from"styled-components";import{useSize as p}from"../../../hooks/useSize.mjs";import{calcModalMaxHeight as n}from"../../../services/calcSize.mjs";import{Backdrop as m}from"../Backdrop/Backdrop.mjs";const s=l.div`
  font-family:
    Lucida Grande,
    Lucida Sans Unicode,
    Helvetica,
    Arial,
    Verdana,
    sans-serif;
  position: absolute;
  top: ${e=>e.$top};
  left: ${e=>e.$left};
  width: ${e=>e.$width};
  height: auto;
  border: 1px solid #aaaaaa;
  border-radius: 4px;
  box-shadow: 0px 8px 16px #888888;
  background-color: #fdfdfd;
`,c=l.div`
  position: relative;
  height: 12px;
  width: 100%;
  padding: 0.4em 0px;
  background: url(images/dialog_title.png) repeat-x #e3e3e3;
  border-bottom: 1px solid #a3a3a3;
  border-radius: 4px 4px 0px 0px;
  cursor: move;
`,h=l.span`
  font-weight: bold;
  float: left;
  margin: 0.1em 16px;
`,x=l.div`
  width: auto;
  height: auto;
  min-height: 63px;
  margin: 0.5em 1em;
  overflow: auto;
`,f=l.div`
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: start;
  align-items: end;
  padding: 0.3em 0 0.6em 0;
  border-top: 1px solid #aaaaaa;
  border-radius: 0px 0px 4px 4px;
`;function u({title:l,open:u,children:g,renderFooter:b,top:$="30px",left:w="405px",width:v="750px"}){const y=a(null),j=r((e=>e(`${n(50)}px`)),[]),k=p(`${n(50)}px`,j);return e(o,{children:u&&i(e(m,{children:e(d,{defaultClassName:"modal",handle:".modal-title",bounds:"parent",nodeRef:y,children:t(s,{$top:$,$left:w,$width:v,ref:y,children:[e(c,{className:"modal-title",children:e(h,{children:l})}),e(x,{className:"modal-content",style:{maxHeight:k},children:g}),e(f,{className:"modal-footer",children:b()})]})})}),document.body)})}export{u as Dialog};
